export default function({ state, commit, dispatch, get }, { updateObj, surveyId, provider, patient, previousObj }) {

    //commit('startUpdatingPatient', update.id)
    console.log(updateObj, surveyId, provider, patient)
    return dispatch('patch', {
        url: '/provider/' + ( state.id ? state.id : provider ) + '/patient/' + patient + '/survey/' + surveyId,
        data: updateObj
    }, {
        root: true
    })
    .then((response) => {
        const newObj = {
            ...previousObj,
            question: updateObj.update
        }
        commit('updatePatient', {
            id: patient,
            survey: [response]
        })
        //commit('finishUpdatingPatient', update.id)
        return response
    })
    .catch((error) => {
        //commit('finishUpdatingPatient', update.id)
        throw error
    })
}

